import { jobsRef } from "../../firebase";

export const fetchJobs = ({ is_get_archive_job, jobs_list_search_text }) => {
    return new Promise((resolve, reject) => {
        let query = jobsRef
            .where("job_archive", "==", is_get_archive_job)
            .orderBy("job_last_message_received_timestamp", "desc")
            .orderBy("job_admin_unread_message_count", "desc")
            .limit(100);

        if (jobs_list_search_text !== "") {
            query = query.where('search_keywords', 'array-contains-any', [jobs_list_search_text.toLowerCase()]);
        }
            
        query.onSnapshot(
            (snapshot) => {
                let jobs = [];
                snapshot.forEach((doc) => {
                    let data = doc.data();
                    jobs.push({
                        doc_id: doc.id,
                        ...data,
                    });
                });
                resolve(jobs);
            },
            (error) => {
                reject(error);
            }
        );
    });
};
